export default __webpack_public_path__ + "static/media/services.a2897c54.svg";